<template>
  <header class="app-header">
    <div class="logo">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
      </svg>
      <span>DocSign</span>
    </div>
    <h1>簽署貸款合約</h1>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    title: {
      type: String,
      default: '簽署貸款合約'
    }
  }
}
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background-color: #fff;
  border-bottom: 1px solid rgba(255, 158, 21, 0.2);
  box-shadow: 0 2px 4px rgba(255, 158, 21, 0.1);
}

.logo {
  display: flex;
  align-items: center;
  color: #FF9E15;
  font-weight: 600;
  font-size: 16px;
  transition: opacity 0.2s ease;
}

.logo:hover {
  opacity: 0.9;
}

.logo svg {
  margin-right: 8px;
  stroke: #FF9E15;
}

h1 {
  margin: 0 auto;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

/* Tablet view */
@media (max-width: 768px) {
  .app-header {
    padding: 12px 16px;
  }

  h1 {
    font-size: 17px;
  }
}

/* Mobile view */
@media (max-width: 480px) {
  .app-header {
    padding: 10px 14px;
  }

  h1 {
    font-size: 16px;
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .logo {
    font-size: 14px;
  }

  .logo svg {
    width: 20px;
    height: 20px;
  }
}

/* Extra small devices */
@media (max-width: 360px) {
  .app-header {
    padding: 8px 12px;
  }

  .logo span {
    display: none;
  }

  .logo svg {
    margin-right: 0;
  }

  h1 {
    max-width: 75%;
  }
}
</style>